import fetch from '../utils/fetch';

// 初始化数据 状态 
export function getReadStatus() {
    return fetch({
        method: 'GET',
        url: 'waterwatt/read/readStatus',
    })
}

// 列表数据查询
export function  getReadList(params) {
    return fetch({
        method: 'GET',
        url: 'waterwatt/read/list',
        params
    })
}

// 录入表示数弹窗 查询
export function getReadReal(params) {
    return fetch({
        method: 'GET',
        url: 'waterwatt/read/real',
        params
    })
}

// 录入表示数 保存
export function readSave(data) {
    return fetch({
        method: 'POST',
        url: 'waterwatt/read/save',
        data
    })
}

// 新增按钮权限测试
export const permissinTest = {
    p:['waterwatt/read/real'],
    request: params => {
        return fetch({
            method: 'GET',
            url: 'waterwatt/read/real',
            params
        })
    }
}